/**
 * Deep link from the admin screen into the Cloudflare AI Gateway.
 *
 * Outbound AI calls carry the user id as gateway metadata, so the
 * gateway can break cost, latency and errors down per user. This link
 * opens that breakdown; the admin matches it against the user id shown
 * on the user's detail page.
 *
 * The view cannot be pinned to a single user from the URL — Cloudflare
 * documents no query parameter for filtering by a metadata value — so
 * the link opens the list grouped by `userId` rather than pretending to
 * filter.
 */

/** Cloudflare account that owns the gateway (mirrors the backend constant). */
const CLOUDFLARE_ACCOUNT_ID = "16d4d9bc631d3d790affb7a6915a337d";

/** Gateway the app's traffic is routed through. */
const AI_GATEWAY = "wordform-app";

/** Window of data to show, in minutes: one week. */
const TIME_WINDOW_MINUTES = 10080;

/**
 * Builds the gateway insights URL broken down by user id.
 *
 * @returns The dashboard URL to open in a new tab.
 */
const aiGatewayInsightsUrl = (): string => {
  const params = new URLSearchParams({
    "time-window": String(TIME_WINDOW_MINUTES),
    attribution: "custom-metadata:userId",
  });

  return `https://dash.cloudflare.com/${CLOUDFLARE_ACCOUNT_ID}/ai/ai-gateway/gateways/${AI_GATEWAY}/insights?${params}`;
};

export { aiGatewayInsightsUrl };
